export const stickyHeadersDocumentList = {
  score: {
    id: 'score_total_capped',
    label: 'Score',
    class: 'score',
    downArrowDirection: 'asc',
    sortable: true,
  },
  title: {
    id: 'title',
    label: 'Title',
    class: 'title',
    downArrowDirection: 'asc',
    sortable: true,
  },
  lastEdited: {
    id: 'revision_modified_at',
    label: 'Last Edited',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  daysLive: {
    id: 'days_published',
    label: 'Days Live',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  unpublished: {
    id: 'unpublished_at',
    label: 'Unpublished',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  created: {
    id: 'created_at',
    label: 'Created',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  reqId: {
    id: 'ats_requisition_id',
    label: 'Req ID',
    class: 'ats-req-id',
    downArrowDirection: 'asc',
    sortable: true,
  },
  location: {
    id: 'location',
    label: 'Location',
    class: 'location',
    downArrowDirection: 'asc',
    sortable: true,
  },
  metadata: {
    id: 'ats_requisition_id',
    label: 'Metadata',
    class: 'ats-req-id',
    downArrowDirection: 'asc',
    sortable: true,
  },
  department: {
    id: 'ats_department_name',
    label: 'Department',
    class: 'department',
    downArrowDirection: 'asc',
    sortable: true,
  },
  visibility: {
    id: 'is_hidden',
    label: 'Visibility',
    class: 'flagship-visibility',
    downArrowDirection: 'asc',
    sortable: true,
  },
  createdIn: {
    id: 'platform',
    label: 'Created In',
    class: 'platform',
    downArrowDirection: 'asc',
    sortable: true,
  },
};

export const stickyHeadersTemplates = {
  score: {
    id: 'score',
    label: 'Score',
    class: 'score',
    downArrowDirection: 'asc',
    sortable: true,
  },
  name: {
    id: 'title',
    label: 'Name',
    class: 'name-header',
    downArrowDirection: 'asc',
    sortable: true,
  },
  createdBy: {
    id: 'created_by',
    label: 'Created By',
    class: 'created-by',
    downArrowDirection: 'asc',
    sortable: true,
  },
  createdDate: {
    id: 'created_at',
    label: 'Created Date',
    class: 'created-date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  lastEdited: {
    id: 'last_edited',
    label: 'Last Edited',
    class: 'last-edited',
    downArrowDirection: 'desc',
    sortable: true,
  },
  status: {
    id: 'is_hidden',
    label: 'Visibility',
    class: 'status',
    downArrowDirection: 'desc',
    sortable: true,
  },
};

export const stickyHeadersRequisitions = {
  title: {
    id: 'title',
    label: 'Requisition Name',
    class: 'req-name',
    downArrowDirection: 'asc',
    sortable: false,
  },
  reqId: {
    id: 'ats_requisition_label',
    label: 'Req ID',
    class: 'req-id',
    downArrowDirection: 'asc',
    sortable: false,
  },
  livePosts: {
    id: 'published_job_posts',
    label: 'Live Posts',
    class: 'count',
    downArrowDirection: 'asc',
    sortable: false,
  },
  totalPosts: {
    id: 'total_job_posts',
    label: 'Total Posts',
    class: 'count',
    downArrowDirection: 'asc',
    sortable: false,
  },
  activeApps: {
    id: 'active_applicants',
    label: 'Active Apps',
    class: 'count applicants',
    downArrowDirection: 'asc',
    sortable: false,
  },
  totalApps: {
    id: 'total_applicants',
    label: 'Total Apps',
    class: 'count applicants',
    downArrowDirection: 'asc',
    sortable: false,
  },
  closedAt: {
    id: 'closed_at',
    label: 'Closed',
    class: 'closed-at',
    downArrowDirection: 'desc',
    sortable: false,
  },
  daysOpen: {
    id: 'opened_at',
    label: 'Days Open',
    class: 'count',
    downArrowDirection: 'desc',
    sortable: false,
  },
  department: {
    id: 'department_name',
    label: 'Department',
    class: 'department',
    downArrowDirection: 'asc',
    sortable: false,
  },
  hiringManager: {
    id: 'hiring_managers',
    label: 'Hiring Manager',
    class: 'hiring-manager',
    sortable: false,
  },
};

export const stickyHeadersEmployees = {
  select: {
    id: '__select',
    label: '',
    class: 'select',
    sortable: false,
  },
  employee: {
    id: 'first_name',
    label: 'Employee',
    class: 'employee',
    downArrowDirection: 'asc',
    sortable: true,
  },
  jobProfile: {
    id: 'job_profile_title',
    label: 'Current Job Profile',
    class: 'job-profile',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: {
      key: 'acknowledgement-header-profile',
    },
  },
  department: {
    id: 'department',
    label: 'Department',
    class: 'department',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: {
      key: 'acknowledgement-header-dept',
    },
  },
  acknowledgementStatus: {
    id: 'acknowledgement_alert',
    label: 'Current Acknowledgement',
    class: 'acknowledgement-status',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: {
      key: 'acknowledgement-header-current-ack',
    },
  },
  daysSinceLastAcknowledgement: {
    id: 'days_since_last_signed',
    label: 'Days Since Last Signed',
    class: 'days-since',
    downArrowDirection: 'desc',
    sortable: true,
    tooltip: {
      key: 'acknowledgement-header-last-signed',
    },
  },
  action: {
    id: 'action',
    label: 'Action',
    class: 'action',
    sortable: false,
  },
  view: {
    id: 'view',
    label: 'View',
    class: 'view',
    sortable: false,
  },
};
